
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';                   // optional
import Paginator from 'primevue/paginator';
import IftaLabel from 'primevue/iftalabel';
import Card from 'primevue/card';
import Button from 'primevue/button';
import Tag from 'primevue/tag';
import ProgressSpinner from 'primevue/progressspinner';
import { computed, onMounted, ref, watch } from 'vue';
import { Transaction } from '../types/transaction';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { main_wallet } from '../apis/main_wallet';
import PopupMainNavbar from '../components/navbar/PopupMainNavbar.vue';
import PopupAffiliateNavbar from '../components/navbar/PopupAffiliateNavbar.vue';
import { useToast } from 'primevue/usetoast';
import { formatCurrency } from '../utils/currency';

export default {
	name: 'AffiliateTransaction',
	methods: { formatCurrency },
	components: {
		DataTable,
		Column,
		ColumnGroup,
		Row,
		Paginator,
		IftaLabel,
		ProgressSpinner,
		Tag,
		Card,
		Button,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();

		const tableLoading = ref(false);
		const first = ref(0);
		const rows = ref(10);

		const transaction = ref<Transaction>({
			records: [],
			totalRecord: 0,
		});

		const totalRecords = computed(() => transaction.value.totalRecord || 0);

		const handleDepositSpecialTransaction = async () => {
			tableLoading.value = true;

			const payload = {
				transactionChannel: 16,
			};

			try {
				const resp = await main_wallet.getDepositSpecialTransaction(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);
				transaction.value = <Transaction>resp.result;
			} catch (error) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: String(error), life: 3000 });
			} finally {
				tableLoading.value = false;
			}
		};

		const onPageChange = (event: any) => {
			first.value = event.first;
			rows.value = event.rows;
		};

		onMounted(() => {
			handleDepositSpecialTransaction();
		});

		watch([first, rows], () => {
			handleDepositSpecialTransaction();
		});

		return {
			profile,
			tableLoading,
			transaction,
			first,
			rows,
			totalRecords,
			onPageChange,
		};
	},
};
